import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import { setTheme } from '@/store/slices/uiSlice';

// 主题管理hook
export const useThemeManager = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.ui.theme);

  useEffect(() => {
    // 监听系统主题变化
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleThemeChange = (e: MediaQueryListEvent) => {
      // 只有在用户没有手动设置主题时才自动切换
      const savedTheme = localStorage.getItem('theme');
      if (!savedTheme) {
        dispatch(setTheme(e.matches ? 'dark' : 'light'));
      }
    };

    // 初始化主题
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
    if (savedTheme) {
      dispatch(setTheme(savedTheme));
    } else {
      dispatch(setTheme(mediaQuery.matches ? 'dark' : 'light'));
    }

    mediaQuery.addEventListener('change', handleThemeChange);

    return () => {
      mediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, [dispatch]);

  // 切换主题的函数
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    dispatch(setTheme(newTheme));
    localStorage.setItem('theme', newTheme);
  };

  // 设置特定主题的函数
  const setSpecificTheme = (newTheme: 'light' | 'dark') => {
    dispatch(setTheme(newTheme));
    localStorage.setItem('theme', newTheme);
  };

  return {
    theme,
    toggleTheme,
    setTheme: setSpecificTheme,
  };
};